module.exports = __webpack_public_path__ + "static/media/secureBadgeImg.221d1ded.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/user-list/images/secureBadgeImg.png
// module id = 14126
// module chunks = 0